import { render, staticRenderFns } from "./short-answer-test.vue?vue&type=template&id=0b415158&scoped=true"
import script from "./short-answer-test.vue?vue&type=script&lang=js"
export * from "./short-answer-test.vue?vue&type=script&lang=js"
import style0 from "./short-answer-test.vue?vue&type=style&index=0&id=0b415158&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b415158",
  null
  
)

export default component.exports